module.exports = __webpack_public_path__ + "img/xiaochengxu.46448eeb.png";